export const removeUndefined = <T extends Record<string, any>>(obj: T): T => {
  const clone = { ...obj };
  Object.keys(clone).forEach(
    (key) => clone[key] === undefined && delete clone[key]
  );
  return clone;
};
